import styled from "styled-components/macro";


export const ReviewAlarmsContainer = styled.div`

height: 72%;

width: 100.1465%;
`;
